<template>
  <div class="promo-suggestion-card" :style="addOnPrice > 0 ? 'border-color: #24488E;' : 'border-color: #56824E;'">
    <div class="flex justify-between promo-suggestion-body-container">
      <div class="flex flex-col gap-1 grow-0" style="flex-basis: 190px;">
        <div class="savings-tag" :style="addOnPrice > 0 ? 'background: #24488E;' : 'background: #56824E;'">
          <span v-if="showUpTo">{{ $t("OrderPage[\"Up to\"]") }}</span>
          {{ currencySymbol + savings }} {{ $t("OrderPage[\"Off\"]") }}</div>
        <div :class="addOnPrice > 0 ? 'suggestion-name-blue' : 'suggestion-name-green'">{{ suggestionName }}</div>
      </div>
      <div v-if="addOnPrice > 0" class="flex flex-col justify-end items-end gap-1">
        <div class="add-on-price-green">+{{ currencySymbol + addOnPrice.toFixed(2) }}</div>
        <div :class="['line-through add-on-original-price', {'opacity-0': !showAddOnOriginalPrice}]">{{ currencySymbol + addOnOriginalPrice.toFixed(2) }}</div>
      </div>
      <div v-else class="flex flex-col justify-end items-end mb-2">
        <div class="add-on-price-red"><span>{{ addOnPrice === 0 ? '+' : '-' }}</span>{{ currencySymbol + Math.abs(addOnPrice).toFixed(2) }}</div>
      </div>
    </div>
    <div>
      <div v-if="addOnPrice > 0" class="mt-1.5 add-on-description-1">
        <p v-if="addOnTestName">{{ $t("OrderPage[\"Add { addOnTestName } save { currencySymbol + savings } on the bundle price!\"]", { addOnTestName: addOnTestName, savings: currencySymbol + savings }) }} </p>
      </div>
      <div v-else class="mt-1.5 add-on-description-2">
        {{
          remainingQuantity > 1
            ? $t("OrderPage[\"Add ${remainingQuantity} more tests for free! Pay ${currencySymbol + Math.abs(addOnPrice).toFixed(2)} less than your current total and save up to ${currencySymbol + savings} overall!\"]", { remainingQuantity: remainingQuantity, addOnPrice: currencySymbol + Math.abs(addOnPrice).toFixed(2), savings: currencySymbol + savings })
            : $t("OrderPage[\"Add ${remainingQuantity} more test for free! Pay ${currencySymbol + Math.abs(addOnPrice).toFixed(2)} less than your current total and save up to ${currencySymbol + savings} overall!\"]", { remainingQuantity: remainingQuantity, addOnPrice: currencySymbol + Math.abs(addOnPrice).toFixed(2), savings: currencySymbol + savings })
        }}
      </div>
    </div>

    <div class="flex items-baseline justify-between mt-1.5">
        <LoginButton link style="color: #979797; font-size: 12px;" @click="$emit('hideSuggestion')">{{ $t("OrderPage[\"Don't show again\"]") }}</LoginButton>
        <button v-if="addOnPrice > 0" class="add-test-btn-blue" @click="$emit('addTest')">{{ addText }}</button>
        <button v-else class="add-test-btn-green" @click="$emit('addTest')">
          {{
            remainingQuantity > 1
              ? $t("OrderPage[\"Choose ${remainingQuantity} more FREE tests\"]", { remainingQuantity: remainingQuantity })
              : $t("OrderPage[\"Choose ${remainingQuantity} more FREE test\"]", { remainingQuantity: remainingQuantity })
          }}
        </button>
    </div>
  </div>
</template>

<script>
import LoginButton from '@/views/login/components/LoginButton.vue';
export default {
  emits: ['hideSuggestion', 'addTest'],
  components: {
    LoginButton
  },
  props: {
    suggestionName: {
      type: String,
      default: ""
    },
    currencySymbol: {
      type: String,
      default: "$"
    },
    savings: {
      type: Number,
      default: 0
    },
    showUpTo: {
      type: Boolean,
      default: false
    },
    addOnPrice: {
      type: Number,
      default: 0
    },
    addOnOriginalPrice: {
      type: Number,
      default: 0
    },
    showAddOnOriginalPrice: {
      type: Boolean,
      default: false
    },
    addOnTestName: {
      type: String,
      default: ""
    },
    remainingQuantity: {
      type: Number,
      default: 0
    }
  },
  computed: {
    addText() {
      if (this.addOnTestName) {
        return this.$t("OrderPage[\"Add promotion test\"]");
      }
      if (this.remainingQuantity) {
        return this.$t(
          this.remainingQuantity > 1
            ? 'OrderPage["Add {count} more promotion tests"]'
            : 'OrderPage["Add {count} more promotion test"]',
          { count: this.remainingQuantity }
        );
      }
      return this.$t("OrderPage[\"Add Test\"]");
    },
  },
}
</script>

<style scoped>
.promo-suggestion-card {
  padding: 12px 16px;
  border-radius: 6px;
  border: 1.5px solid;
  background-image: url('../../../../../assets/orderTest/order-page/in-app-promo/background.png');
}

.promo-suggestion-body-container {
  padding: 8px;
  border-radius: 8px;
  min-height: 76px;
  background: linear-gradient(93deg, rgba(179, 195, 233, 0.81) 2.04%, rgba(255, 233, 168, 0.81) 46.88%);
}

.savings-tag {
  padding: 3px 20px;
  border-radius: 19px;
  color: #FFF;
  font-size: 13px;
  font-weight: 400;
  line-height: normal;
  width: fit-content;
}

.suggestion-name-blue {
  color: #24488E;
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
}

.suggestion-name-green {
  color: #56824E;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
}

.add-on-price-green {
  color: #84BC3B;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}

.add-on-price-red {
  color: #E24E4E;
  font-family: "DM Sans";
  font-size: 22px;
  font-weight: 600;
  line-height: normal;
}

.add-on-original-price {
  color: #C9CACD;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
}

.add-on-description-1 {
  color: #24488E;
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.add-on-description-2 {
  color: #333;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
}

.add-test-btn-blue {
  border-radius: 26px;
  padding: 0 14px;
  height: 27px;
  border: 1px solid #24488E;
  background: #FFF;
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.25);
  color: #24488E;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  width: 60%;
  line-height: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.add-test-btn-green {
  border-radius: 26px;
  padding: 0 14px;
  height: 27px;
  border: 1px solid #56824E;
  background: #FFF;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.25);
  color: #56824E;
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>

